/**
 * QuickForm Class
 * Quick Form 제출 처리
 */
import { Modal } from '../ui/Modal.js';

export class QuickForm {
    constructor() {
        this.isInitialized = false;
    }

    init() {
        if (this.isInitialized) return;
        
        // 전역으로 한 번만 등록 (중복 방지)
        document.addEventListener('submit', async (e) => {
            const form = e.target;
            if (!form || (form.id !== 'quickForm' && form.id !== 'quickFormModalForm')) {
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            await this.handleSubmit(form);
        }, true); // capture phase에서 처리하여 중복 방지
        
        this.isInitialized = true;
    }

    async handleSubmit(form) {
        // 중복 제출 방지
        const submitBtn = form.querySelector('button[type="submit"]');
        if (form.dataset.submitting === 'true') {
            return;
        }
        form.dataset.submitting = 'true';
        
        if (submitBtn) {
            submitBtn.disabled = true;
            const originalText = submitBtn.textContent;
            submitBtn.textContent = '처리 중...';
            submitBtn.dataset.originalText = originalText;
        }
        
        const formData = new FormData(form);
        const data = {
            name: formData.get('name') || '',
            contact: formData.get('contact') || '',
            procedure: formData.get('procedure') || '',
            privacy_agree: formData.get('privacy_agree') || ''
        };

        // 유효성 검사
        if (!data.name.trim() || !data.contact.trim() || !data.procedure || !data.privacy_agree) {
            // 번역 키는 서버에서 처리하므로 기본 메시지 사용
            Modal.error('모든 필수 항목을 입력해주세요.', '상담신청');
            // finally 블록에서 처리되므로 여기서는 return만
            return;
        }

        try {
            // AJAX 제출 (form-data)
            const formDataToSend = new FormData();
            formDataToSend.append('name', data.name);
            formDataToSend.append('contact', data.contact);
            formDataToSend.append('procedure', data.procedure);
            formDataToSend.append('privacy_agree', data.privacy_agree);
            
            const response = await fetch('/api/quick-form', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formDataToSend
            });

            // 응답 상태 확인
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                Modal.success('상담 신청이 완료되었습니다.', '상담신청', {
                    onClose: () => {
                        form.reset();
                        // Select 값도 초기화
                        const selectElement = form.querySelector('[data-select]');
                        if (selectElement) {
                            const nativeSelect = selectElement.querySelector('.no-form-select__native');
                            if (nativeSelect) {
                                nativeSelect.selectedIndex = 0;
                                nativeSelect.dispatchEvent(new Event('change'));
                            }
                        }
                        // 모달이 열려있으면 닫기
                        const modal = document.getElementById('quickFormModal');
                        if (modal && modal.classList.contains('is-open')) {
                            const closeBtn = modal.querySelector('.no-quick-form-modal__close');
                            if (closeBtn) closeBtn.click();
                        }
                    }
                });
            } else {
                Modal.error(result.message || '상담 신청 중 오류가 발생했습니다.', '상담신청');
            }
        } catch (error) {
            console.error('Error:', error);
            Modal.error('상담 신청 중 오류가 발생했습니다.', '상담신청');
        } finally {
            // 항상 버튼 상태 복원
            form.dataset.submitting = 'false';
            if (submitBtn && submitBtn.dataset.originalText) {
                submitBtn.disabled = false;
                submitBtn.textContent = submitBtn.dataset.originalText;
            }
        }
    }
}

